import { combineReducers } from 'redux'
import data from './data'
import { getIsLoadingReducer } from 'root/reducers/common'
import * as actions from '../../actions'

export default combineReducers({
  data,
  isLoading: getIsLoadingReducer(actions, 'loadOrderList', false),
})
